import { API } from './config-auth.api';
import { API as API_BACKEND } from './config-backend.api';
import { API as API_SERVICE } from './config-service.api';
import { ICreateAccount, ILogin } from '../interfaces/auth.interface';
import { PATHS } from '../const/paths.constants';

export const validateEmail = (email: string) => API_SERVICE.post(`${PATHS.DRIVERS}/validate-email`, { email });

export const login = ({ email, password }: ILogin) => API.post('/login', {
    email,
    password,
    role: 'deliveryPartner',
});

export const signup = (data: ICreateAccount) => API_BACKEND.post('/customer/registerFromEmail', data);

export const deliveryMarketingData = (payload: any) => API_BACKEND.post(
    '/deliveryPartnerMarketingData/registerMarketingData',
    payload,
);

export const loginWithToken = (token: any) => API_BACKEND.post(
    '/user/accessTokenLogin',
    { deviceType: 'WEB' },
    {
        headers: {
            authorization: `Bearer ${token}`,
        },
    },
);

export const forgotPassword = (payload: any) => API.post('/forgotPassword', payload);

export const confirmPassword = (payload: any) => API_BACKEND.put('/user/resetPassword', payload);
